import { useEffect, useRef } from "react";

export const TeamsLanding = () => {
  const iframeRef = useRef(null);

  useEffect(() => {
    // When iframe loads an internal link (like /), navigate the parent
    const iframe = iframeRef.current;
    if (!iframe) return;

    const handleLoad = () => {
      try {
        const iframePath = iframe.contentWindow?.location?.pathname;
        // If iframe navigated away from the teams page, redirect parent
        if (iframePath && !iframePath.includes('teams-page')) {
          window.location.href = iframePath;
        }
      } catch (e) {
        // Cross-origin — ignore
      }
    };

    iframe.addEventListener('load', handleLoad);
    return () => iframe.removeEventListener('load', handleLoad);
  }, []);

  return (
    <iframe
      ref={iframeRef}
      src="/teams-page.html"
      title="ClarityOS Teams"
      data-testid="teams-landing-iframe"
      style={{
        position: 'fixed',
        top: 0,
        left: 0,
        width: '100vw',
        height: '100vh',
        border: 'none',
        margin: 0,
        padding: 0,
        overflow: 'hidden',
      }}
    />
  );
};
